import { jsx as _jsx } from "react/jsx-runtime";
import { ProgressCircle } from './progress-circle';
import clsx from 'clsx';
export function FullPageLoader({ className, screen }) {
    return (_jsx("div", { className: clsx('flex items-center justify-center flex-auto', screen ? 'h-screen w-screen' : 'h-full w-full', className), children: _jsx(ProgressCircle, { isIndeterminate: true, "aria-label": "Loading page..." }) }));
}
